import React, { useEffect, useLayoutEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import ReplyIcon from "@mui/icons-material/Reply";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Switch,
  Button,
  Select,
  MenuItem,
  SelectChangeEvent,
  Typography,
  Tabs,
  Tab,
  Popper,
  ClickAwayListener,
  Paper,
  Chip,
  TextField,
  InputAdornment,
} from "@mui/material";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import SearchBar from "../../components/SearchBar";
// import {
//   useEditUserMutation,
//   useGetPendingAgentQuery,
//   useDeleteByIduserMutation,
//   useLazyGetPendingAgentQuery,
// } from "../../services/users";

import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { errorToast, successToast } from "../../helpers/toast";
import Pagination from "../../components/Pagination";
// import WarnModal from "../../components/WarnModal";
import Loader from "../../helpers/constants/Loader";
// import { useLazyExportAgentCsvQuery } from "../../services/dashboard";
// import { useLazyGetPerformanceInsightsQuery } from "../../services/performace";
import moment from "moment";
import { DayPicker } from "react-day-picker";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ReasonModal from "../../components/RejectReason";
import { getFromStorage, STORAGE_KEYS } from "../../helpers";
import { setCredentials } from "../../reducers/authSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import {
  getAgentCount,
  getCompanyCount,
  getCompanyRequestCount,
  getPropertyRequestCount,
  setRequestCount,
} from "../../reducers/generalSlice";
// import RevertModal from "../../components/RevertBack";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageSupport = () => {
  const dispatch = useAppDispatch();

  const agentCount = useAppSelector(getAgentCount);
  const companyCount = useAppSelector(getCompanyCount);
  const companyRequestCount = useAppSelector(getCompanyRequestCount);
  const propertyRequestCount = useAppSelector(getPropertyRequestCount);

  const { state } = useLocation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const insight = pathname?.includes("insights");
  const [searchParams, setSearchParams] = useSearchParams();
  let role = 5;
  // const [rows, setRows] = useState<any>([]);
  // const [editUSERbyId] = useEditUserMutation();

  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount1] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  let totalPages = Math.ceil(totalCount / limit);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  // const [editCompanybyId] = useEditUserMutation();
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedCompany, setSelectedCompany] = useState<string>("");

  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows([]);
  };
  const [rejectionReason, setRejectionReason] = useState<string>("");
  const [openReject, setOpenReject] = useState(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [exportCsv] = useLazyExportAgentCsvQuery();
  // const [getPendingCompany] = useLazyGetPendingAgentQuery();
  // const [deleteUserById] = useDeleteByIduserMutation();
  // const [getDataInsight] = useLazyGetPerformanceInsightsQuery();
  const [open1, setOpen1] = useState(false); // Control calendar visibility
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedChip, setSelectedChip] = useState("");
  const [month, setMonth] = useState(new Date());
  const [value, setValue] = React.useState(0);
  const [rows, setRows] = useState<any>([
    {
      _id: 1,
      name: "Arya Biswas",
      dialCode: "+971",
      phoneNo: "6297411185",
      email: "john.doe@example.com",
      address: "Kharar Mohali",
      role: "Admin",
      status: true,

      industryType: "Wholesaler",
      businessName: "Grocery Services",
      Reasonforqueries: "Wrong Product Delivered",
      description: "dummy data",
    },
    {
      _id: 2,
      name: "Rihana Roy",
      phoneNo: "8393911185",
      email: "jane.doe@example.com",
      dialCode: "+971",
      address: "Dubai Abu Dhabi",
      role: "User",

      industryType: "Wholesaler",
      businessName: "Soft drinks Services",
      Reasonforqueries: "Packaging Issue",
      description: "dummy data",
    },
    //... more users
  ]);
  const [range, setRange] = useState<{
    from: Date | undefined;
    to: Date | undefined;
  }>({
    from: undefined,
    to: undefined,
  });

  const [dataCount, setDataCount] = useState({
    pendingRequests: 2,
    aproovedRequests: 2,
    rejectedRequests: 2,
    deactivatedRequests: 2,
  });

  const handleClose = () => {
    setOpen1(false);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const getFormattedRange = () => {
    if (range?.from && range?.to) {
      return `${moment(range.from).format("MM/DD/YYYY")} - ${moment(
        range.to
      ).format("MM/DD/YYYY")}`;
    } else if (range?.from) {
      return moment(range.from).format("MM/DD/YYYY");
    }
    return "";
  };

  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
    }
  };
  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip("");
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === "lastMonth") {
      newRange = {
        from: moment().subtract(1, "months").startOf("month").toDate(),
        to: moment().subtract(1, "months").endOf("month").toDate(),
      };
    } else if (value === "lastWeek") {
      newRange = {
        from: moment().subtract(7, "days").startOf("day").toDate(),
        to: today.toDate(),
      };
    } else if (value === "lastYear") {
      newRange = {
        from: moment().subtract(1, "years").startOf("year").toDate(),
        to: moment().subtract(1, "years").endOf("year").toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPage(1);
  };

  useLayoutEffect(() => {
    if (state) {
      setValue(state);
    }
  }, []);

  return (
    <div>
      {/* <Loader isLoad={isLoading || load} /> */}
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">Customer/Vendor Support</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header" marginBottom={"20px"}>
            <Box className="cards_header_left">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
              <div className="control_group">
                <TextField
                  // label="Select Date Range"
                  variant="outlined"
                  hiddenLabel
                  className="text_field-range"
                  fullWidth
                  onClick={handleClick}
                  value={getFormattedRange()}
                  placeholder="Select Date Range"
                  InputProps={{
                    readOnly: true,
                    endAdornment: range?.from ? (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setRange({
                              from: undefined,
                              to: undefined,
                            });
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    ) : (
                      <InputAdornment position="end">
                        <IconButton>
                          <CalendarTodayIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <Popper
                open={open1}
                anchorEl={anchorEl}
                placement="bottom-start"
                disablePortal
                style={{
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <Paper
                    elevation={3}
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    <div
                      style={{
                        padding: 16,
                        borderRadius: 10,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <Chip
                          label="Last Week"
                          variant={
                            selectedChip === "lastWeek" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastWeek")}
                        />
                        <Chip
                          label="Last Month"
                          variant={
                            selectedChip === "lastMonth" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastMonth")}
                        />
                        <Chip
                          label="Last Year"
                          variant={
                            selectedChip === "lastYear" ? "filled" : "outlined"
                          }
                          onClick={() => handleChipClick("lastYear")}
                        />
                      </div>

                      <DayPicker
                        className="react-day-picker"
                        mode="range"
                        selected={range}
                        onSelect={handleSelect}
                        // numberOfMonths={10}
                        month={month}
                        onMonthChange={handleMonthChange}
                        // styles={{
                        //   months: { display: "flex", gap: "16px" },
                        //   month: { margin: 0 },
                        // }}
                      />
                    </div>
                  </Paper>
                </ClickAwayListener>
              </Popper>
            </Box>
            {insight ? null : (
              <Box className="cards_header_right">
                {/* <Button
                  className="btn btn_primary"
                  onClick={() => navigate("/manage-vendors/add")}
                >
                  <AddIcon /> Add Vendor
                </Button> */}
                <Button
                  className="btn btn_primary"
                  // onClick={handleExportCsv}
                  disabled={rows?.length === 0 ? true : false}
                >
                  <FileDownloadIcon /> Export CSV
                </Button>
              </Box>
            )}
          </Box>
          <Box className="custom_tabs">
            {insight ? null : (
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab
                  label={`Customer (${dataCount?.pendingRequests})`}
                  {...a11yProps(0)}
                />
                <Tab
                  label={`Vendor (${dataCount?.aproovedRequests})`}
                  {...a11yProps(1)}
                />
              </Tabs>
            )}
            <CustomTabPanel value={value} index={0}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      {/* <TableCell>User Id</TableCell> */}
                      <TableCell>Image</TableCell>
                      <TableCell>Full Name</TableCell>
                      <TableCell>Phone Number</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Reason for queries</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Revert Back</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No user found
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.name}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-vendors/details/${row?._id}`)
                              }
                              className="user_img"
                            >
                              <img
                                src={row?.image || "/static/images/cr7.png"}
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.name || "-"}</TableCell>

                          <TableCell>
                            {row?.dialCode + row?.phoneNo || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.Reasonforqueries || "-"}</TableCell>
                          <TableCell>{row?.description || "0"}</TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton>
                                <ReplyIcon />
                              </IconButton>
                              {/* <RevertModal onRevert={handleRevertAction} /> */}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* {rows?.length > 0 ? (
                <Pagination
                  setPage={setPage}
                  module={rows}
                  page={page}
                  onPageChange={onPageChange}
                  totalPages={totalPages}
                  limit={limit}
                  setLimit={setLimit}
                />
              ) : (
                ""
              )} */}
              {/* <WarnModal
                open={open}
                setOpen={setOpen}
                handleDelete={() => handleDeleteCompany(selectedId)}
                name="User"
              /> */}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S.No</TableCell>
                      {/* <TableCell>User Id</TableCell> */}
                      <TableCell>Image</TableCell>
                      <TableCell>Full Name</TableCell>
                      <TableCell>Phone Number</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Reason for queries</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Revert Back</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows?.length == 0 ? (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          No user found
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((row: any, i: any) => (
                        <TableRow key={row.name}>
                          <TableCell align="center">
                            {(page - 1) * 10 + i + 1}
                          </TableCell>
                          {/* <TableCell>{row?.referenceId || "-"}</TableCell> */}
                          <TableCell>
                            <figure
                              onClick={() =>
                                navigate(`/manage-vendors/details/${row?._id}`)
                              }
                              className="user_img"
                            >
                              <img
                                src={row?.image || "/static/images/cr7.png"}
                                alt=""
                              />
                            </figure>
                          </TableCell>
                          <TableCell>{row?.name || "-"}</TableCell>

                          <TableCell>
                            {row?.dialCode + row?.phoneNo || "-"}
                          </TableCell>
                          <TableCell>{row?.email || "-"}</TableCell>
                          <TableCell>{row?.Reasonforqueries || "-"}</TableCell>
                          <TableCell>{row?.description || "0"}</TableCell>
                          <TableCell>
                            <Box className="table_actions">
                              <IconButton>
                                <ReplyIcon />
                              </IconButton>
                              {/* <RevertModal onRevert={handleRevertAction} /> */}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* {rows?.length > 0 ? (
                <Pagination
                  setPage={setPage}
                  module={rows}
                  page={page}
                  onPageChange={onPageChange}
                  totalPages={totalPages}
                  limit={limit}
                  setLimit={setLimit}
                />
              ) : (
                ""
              )} */}
              {/* <WarnModal
                open={open}
                setOpen={setOpen}
                handleDelete={() => handleDeleteCompany(selectedId)}
                name="User"
              /> */}
            </CustomTabPanel>
          </Box>
        </Card>
      </div>
      {/* <ReasonModal
        open={openReject}
        setOpen={setOpenReject}
        handleDelete={handleReject}
        reason={rejectionReason}
        setReason={setRejectionReason}
      /> */}
    </div>
  );
};

export default ManageSupport;
